<template>
  <div>
    <span :class="iconClasses" />
  </div>
</template>

<script>
export default {
  props: {
    white: { type: Boolean },
    expanded: { type: Boolean },
  },
  computed: {
    iconClasses() {
      return {
        icon: true,
        'icon-white': this.white,
        'icon-blue': !this.white,
        hamburger: !this.expanded,
        close: this.expanded,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/settings/config.scss";
  .icon {
    display: block;
    width: 19px;
    height: 19px;
  }
  .icon-blue {
    &.hamburger {
      background-image: svg-load("icons/hamburger.svg", stroke=#050817);
    }
    &.close {
      background-image: svg-load("icons/hamburger-close.svg", stroke=#050817);
    }
  }
  .icon-white {
    &.hamburger {
      background-image: svg-load("icons/hamburger.svg", stroke=#ffffff);
    }
    &.close {
      background-image: svg-load("icons/hamburger-close.svg", stroke=#ffffff);
    }
  }
</style>
